import { Button, Stack } from '@material-ui/core';
import React from 'react';
import { useQuery, useMutation } from 'react-query';
import { editHistory, getHistory } from 'src/services/doctor.service';
import RichText from './RichText';
import { queryClient } from 'src';
import SaveIcon from '@mui/icons-material/Save';

function History({ id, saved, setSaved }) {
  const {
    isLoading: fetchLoading,
    isError: fetchError,
    data: text
  } = useQuery(['history', id], () => getHistory(id));
  const {
    mutate,
    isLoading: editHistoryLoading,
    isError: editHistoryError
  } = useMutation(
    async () => {
      newText == null ? await editHistory(id, text?.data) : await editHistory(id, newText);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['history', id]);
        setSaved(true);
      }
    }
  );
  const [newText, setNewText] = React.useState(null);
  return (
    <Stack
      direction={'column'}
      justifyContent={'space-between'}
      style={{ height: '100%', padding: '2%' }}
    >
      <RichText
        newText={newText}
        setNewText={setNewText}
        loading={fetchLoading || editHistoryLoading}
        error={fetchError || editHistoryError}
        originalText={text?.data}
        saved={saved}
        setSaved={setSaved}
      />

      <Stack
        direction={'row'}
        style={{
          paddingTop: '1%',
          justifyContent: 'flex-end'
        }}
      >
        {!saved ? (
          <p
            style={{
              color: 'red',
              fontSize: '12px',
              fontWeight: 'bold',
              marginRight: '20px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            You have unsaved changes
          </p>
        ) : null}
        <Button
          variant="contained"
          color="primary"
          onClick={mutate}
          style={{ fontSize: 'large', padding: '5px 15px' }}
        >
          <SaveIcon style={{ marginRight: '5px' }} />
          Save
        </Button>
      </Stack>
    </Stack>
  );
}

export default History;
